import Util from '@/lib/util'
export default [
    {
        title:Util.L('Order'),
        key:'orderNo',
        width: 50,
        fixed:'left'
      },
    {
        title:Util.L('Sku'),
        width: 200,
        key:'sku',
        fixed:'left'
    },
    {
        title:Util.L('Name'),
        width: 200,
        key:'productName',
        fixed:'left'
    },
    {
        title:Util.L('ModelSku'),
        width: 200,
        key:'modelSku',
        fixed:'left'
    },
    {
        title: Util.L("ExportBrandName"),
        width: 200,
        key: "exportBrandName",
        fixed:'left'
    },
    {
        title:Util.L('Unit'),
        width: 120,
        key:'unitName'
    },
    {
        title:Util.L('Price'),
        width: 100,
        key:'price',
        align: "right",
        render: (h:any,params:any) =>{
            return h('span', Util.toViewNumberString(params.row.price));
        }
    },
    {
        title: `Thể tích`,
        key: "qty",
        width: 120,
        align: "right",
        render: (h: any, params: any) => {
          return h("span", Util.formatLocateNumber(params.row.product.volumeM3 * params.row.orderQty, 6));
        },
      },
    {
        title:Util.L('ShortQty'),
        width: 100,
        key:'shortQty',
        align: "right",
        render: (h:any,params:any) =>{
            return h('span', Util.toViewNumberString(params.row.shortQty));
        }
    },
    {
        title:Util.L('OrderQty'),
        width: 100,
        key:'orderQty',
        align: "right",
        render: (h:any,params:any) =>{
            return h('span', Util.toViewNumberString(params.row.orderQty));
        }
    },
    {
        title:Util.L('AllocatingQty'),
        slot: 'allocatingQty',
        width: 150,
        align: "right",
    },
    {
        title:Util.L('PickedQty'),
        key: 'pickedQty',
        width: 100,
        align: "right",
        render: (h:any,params:any) =>{
            return h('span', Util.toViewNumberString(params.row.pickedQty));
        }
    },
    {
        title:Util.L('PickingRepickQty'),
        key: 'pickingRepickQty',
        width: 100,
        align: "right",
        render: (h:any,params:any) =>{
            return h('span', Util.toViewNumberString(params.row.pickingRepickQty));
        }
    },
    {
        title:Util.L('ConfirmPackingQty'),
        slot: 'confirmPackingQty',
        align:"right",
        width: 150
    },
    {
        title:Util.L('PackedQty'),
        slot: 'packedQty',
        align: 'right',
        width: 100
    },
    {
        title:Util.L('AssetType'),
        width: 200,
        key:'assetTypeName'
    },
    {
        title:Util.L('ConditionType'),
        width: 150,
        key:'conditionTypeName'
    },
    {
        title:Util.L('VATPercent'),
        width: 100,
        key:'vatPercent',
        align: "right",
        render: (h:any,params:any) =>{
            return h('span', Util.toViewNumberString(params.row.vatPercent));
        }
    }
]